export const NEWSLETTER_MESSAGES = {
  SUCCESS: "Success! You're on the list.",
  INVALID_EMAIL: 'Invalid email format. Example: name@example.com',
  REQUIRED: 'This field is required.',
  ERROR: 'Something went wrong. Please try again.',
} as const;
